import React from 'react';
import { Row, Col } from 'reactstrap';
import { UsageTransfer } from '@qsightpbi-integration/sdk';
import './UsageTransferTable.css';

interface TransferOpportunitiesRowProps {
    row: UsageTransfer.Props
    rowIndex: number;
    expandedRows: string[];
    setExpandedRows: (rows: string[]) => void;
}

const TransferOpportunitiesRow: React.FC<TransferOpportunitiesRowProps> = ({ row, rowIndex, expandedRows, setExpandedRows }) => {
    const rowKey = String(rowIndex);
    const isExpanded = expandedRows.includes(rowKey);

    return (
        <tr className={`transfer-opportunities-row extra-info-row ${isExpanded ? 'expanded' : ''}`}>
            <td colSpan={3} className='p-0'>
                <Row className={`d-${isExpanded ? 'flex' : 'none'} p-3`}>
                    <Col xs={12} md={6} >
                        <strong className='extra-info-text'>Products to Transfer: </strong>
                        {row.lotDetails?.map((lot, lotIndex) => (
                            <Row key={lotIndex}>
                                <Col xs={4} >
                                    <span className='extra-info-text'>Lot #: <strong>{lot.lotNumber ?? 'N/A'}</strong></span>
                                </Col>
                                <Col xs={4} >
                                    <span className='extra-info-text'>Expiration Date: <strong>{lot.expirationDate ?
                                        new Date(lot.expirationDate).toLocaleDateString('en-US', {
                                            year: 'numeric',
                                            month: 'long',
                                            day: 'numeric'
                                        }) : null}</strong></span>
                                </Col>
                                <Col xs={4} >
                                    <span className='extra-info-text'>Qty On Hand: <strong>{lot.qtyOnHand ?? 'N/A'}</strong></span>
                                </Col>
                            </Row>
                        ))}
                    </Col>
                    <Col xs={12} md={6} >
                        <strong className='extra-info-text'>Places to Transfer:</strong>
                        {row.destinationDetails?.map((option, optionIndex) => (
                            <Row key={optionIndex}>
                                <Col xs={6} >
                                    <span className='extra-info-text'>To: <strong>{option.transferToDepartmentName ?? 'N/A'}</strong>,&nbsp;
                                        {option.transferToHospitalName ?? 'N/A'}</span>
                                </Col>
                                <Col xs={6} >
                                    <span className='extra-info-text'>Needed:  <strong>{option.transferToQtyNeeded}</strong></span>
                                </Col>
                            </Row>
                        ))
                        }
                    </Col >
                </Row >
            </td>
        </tr>
    );
};

export default TransferOpportunitiesRow;